import { isProd } from "../services/env";

export const isCap = (value) => {
    if (value === null || value === undefined) return null;
    return /^[0-9]{5}$/.test(value);
};

export const isCf = (value) => {
    if (value === null || value === undefined) return null;
    return (
        null !==
            value.match(
                /^(?:[A-Z][AEIOU][AEIOUX]|[B-DF-HJ-NP-TV-Z]{2}[A-Z]){2}(?:[\dLMNP-V]{2}(?:[A-EHLMPR-T](?:[04LQ][1-9MNP-V]|[15MR][\dLMNP-V]|[26NS][0-8LMNP-U])|[DHPS][37PT][0L]|[ACELMRT][37PT][01LM]|[AC-EHLMPR-T][26NS][9V])|(?:[02468LNQSU][048LQU]|[13579MPRTV][26NS])B[26NS][9V])(?:[A-MZ][1-9MNP-V][\dLMNP-V]{2}|[A-M][0L](?:[1-9MNP-V][\dLMNP-V]|[0L][1-9MNP-V]))[A-Z]$/i
            ) && checkCfLastDigit(value)
    );
};

const checkCfLastDigit = (cf) => {
    // no way we can build the oddTable dynamically...
    // prettier-ignore
    const oddTable = { "0": 1, "1": 0, "2": 5, "3": 7, "4": 9, "5": 13, "6": 15, "7": 17, "8": 19, "9": 21, A: 1, B: 0, C: 5, D: 7, E: 9, F: 13, G: 15, H: 17, I: 19, J: 21, K: 2, L: 4, M: 18, N: 20, O: 11, P: 3, Q: 6, R: 8, S: 12, T: 14, U: 16, V: 10, W: 22, X: 25, Y: 24, Z: 23 };

    // ...as opposed to the evenTable
    const evenTable = {};
    const allLetters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
    for (let i = 0; i < allLetters.length; i++) {
        if (i < 10) evenTable[i] = i;
        evenTable[allLetters[i]] = i;
    }

    try {
        // now we can "remove" the last digit from the CF and use it for comparison later...
        const allChars = cf.toUpperCase().split("");
        const lastDigit = allChars.pop();

        // ...and reduce both to their mapped sum
        let oddSum = allChars
            .filter((char, idx) => (idx + 1) % 2 != 0)
            .reduce((a, b) => {
                return a + oddTable[b];
            }, 0);
        let evenSum = allChars
            .filter((char, idx) => (idx + 1) % 2 == 0)
            .reduce((a, b) => {
                return a + evenTable[b];
            }, 0);

        // finally, compare the actual last digit with the calculated one
        return allLetters[(evenSum + oddSum) % 26] == lastDigit;
    } catch (error) {
        if (!isProd()) console.log(error);
        return false;
    }
};

export const isName = (val) => {
    if (val === null || val === undefined) return null;
    // return null !== val.match(/^[a-z \*]+$/i) && val.length > 1 && val.replaceAll(" ", "").length > 1;
    return null !== val.match(/^[ a-zA-ZàèìòùÀÈÌÒÙáéíóúýÁÉÍÓÚÝâêîôûÂÊÎÔÛãñõÃÑÕäëïöüÿÄËÏÖÜŸçÇßØøÅåÆæœ'`'\*]+$/i) && val.length > 1 && val.replaceAll(" ", "").length > 1;
};

export const isEmail = (val) => {
    if (val === null || val === undefined) return null;
    return null !== val.match(/^[a-zA-Z0-9\*._-]+@[a-zA-Z0-9\*.-]+\.[a-zA-Z\*]{2,20}$/);
};

export const isPhone = (val) => {
    if (val === null || val === undefined) return null;
    return null !== val.match(/^[\+]?[(]?[0-9\*]{3}[)]?[-\s\.]?[0-9\*]{3}[-\s\.]?[0-9\*]{3,6}$/im);
};

export const isStringNotEmpty = (val) => {
    return typeof val == "string" && val.length > 0;
};
